<template>
  <div>
    <span v-if="row.diffSign === 'N'">正常数据</span>
    <span v-if="row.diffSign === 'Y'" style="color:#E64652">差异数据</span>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => []
    }
  }
}
</script>

<style></style>
